<template>
  <div class="fullHeight" id="integration-confirmation">
    <mu-flexbox justify="center" align="center" style="height: 100%;">
      <mu-flexbox-item align="center" class="white">
        <mu-row>
          <mu-col width="100" tablet="33" desktop="33"></mu-col>
          <mu-col width="100" tablet="33" desktop="33" align="center">
            <div v-if="type === 'FITBIT'">
              <img src="static/integrations/fitbit.svg" width="20%"/>
              <div class="title">
                Congratulations!
              </div>
              <div class="subTitle">
                You are now integrated with FitBit
              </div>
            </div>


            <div v-if="type === 'STRIIV'">
              <img src="static/integrations/striiv.png" width="20%"/>
              <div class="title">
                Congratulations!
              </div>
              <div class="subTitle">
                You are now integrated with Striiv
              </div>
            </div>

          </mu-col>
          <mu-col width="100" tablet="33" desktop="33"></mu-col>
        </mu-row>
      </mu-flexbox-item>
    </mu-flexbox>
  </div>
</template>
<script>

  import StriivApi from '../../api/Striiv';

  export default {
    data() {
      return {
        type: "FITBIT"
      }
    },
    methods: {
      doStriivImport() {
        let self = this;
        StriivApi.massImportHeartRate().then(response => {
          self.$toastr.success('Synchronizing heart rate data to your health tracking profile. This may take up to 5 - 10 minutes to complete.');
        });
      }
    },
    mounted() {
      let self = this;
      self.type = self.$route.query.name;
      if ( self.type === 'STRIIV' ) {
        self.doStriivImport();
      }
    }
  }

</script>
<style lang="less">
  #integration-confirmation {
    img {
      margin-bottom: 16px;
    }
    .title {
      font-size: 18px;
      margin-bottom: 4px;
    }
    .subTitle {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// IntegratedConfirmation.vue?a15dfe3a